import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPuzzle12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPuzzle12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Puzzle12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M3.88 3.4H1.5a.5.5 0 0 0-.5.5v6.6a.5.5 0 0 0 .5.5h1.34v-.44a1.96 1.96 0 1 1 3.92 0V11H8.1a.5.5 0 0 0 .5-.5V8.12h1.48a.92.92 0 0 0 0-1.84H8.6V3.9a.5.5 0 0 0-.5-.5H5.72V1.92a.92.92 0 0 0-1.84 0zm5.72 6.72v-1h.48a1.92 1.92 0 1 0 0-3.84H9.6V3.9a1.5 1.5 0 0 0-1.5-1.5H6.72v-.48a1.92 1.92 0 0 0-3.84 0v.48H1.5A1.5 1.5 0 0 0 0 3.9v6.6A1.5 1.5 0 0 0 1.5 12h2.34v-1.44a.96.96 0 1 1 1.92 0V12H8.1a1.5 1.5 0 0 0 1.5-1.5z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Puzzle12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconPuzzle12);
